<div class="row">
  <div class="col-lg-12">
    <div class="container-fluid pl-0 info-list has-info-icon height-unset">
      <h3 class="sub-title">
        Traffic Overview
        <a class="btn btn-link help-icon p-0" data-toggle="tooltip"
          title="Traffic volume and ad inventory estimates for the app along with associated advertising risk factors.">
          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
        </a>
      </h3>
    </div>
  </div>
</div>
<div class="row">
  <div class='col-lg-6 info-row'>
    <div class="info-column">
      <div class="info-section">
        <div class="info-list-2">
          <info-list-item label='Potential Bundle Id Spoofing Risk' [lock]='isFreemium'
            labelTooltip='The risk the app may be misrepresented in advertising transactions and ads delivered to a different app or site'>
            <risk-heat-meter #value [risk]='data?.trafficOverview?.appSpoofingRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Advertising IVT Risk' [lock]='isFreemium'
            labelTooltip='The risk of advertising impressions delivered to the app being due to invalid traffic (IVT).  IVT risk is derived from standardized definitions of invalid traffic maintained by the Media Rating Council, Inc. (MRC) and the Interactive Advertising Bureau (IAB).'>
            <risk-heat-meter #value [risk]='data?.trafficOverview?.advertisingIvtRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Trusted Seller'
            labelTooltip='Pixalate crunches the data to rate sellers representing this app on the basis of a number of factors including audience reach and invalid traffic risk.'>
            <ng-container #value>
              <ng-container
                *ngIf="data?.trafficOverview?.topTrustedSellerId && data?.trafficOverview?.topTrustedSellerId != 'N/A'">
                <img src="//cdn.pixalate.com/sellers/icons/apn/16x16/{{data?.trafficOverview?.topTrustedSellerId}}.jpg"
                  width="16" height="16" alt="Seller Icon" />
                {{data?.trafficOverview?.topTrustedSellerName}}
              </ng-container>
              <ng-container
                *ngIf="!data?.trafficOverview?.topTrustedSellerId || data?.trafficOverview?.topTrustedSellerId === 'N/A'">
                N/A
              </ng-container>
            </ng-container>
          </info-list-item>
          <info-list-item label='Ad Density'>

            <ng-container #value>
              <ng-container *ngIf="data?.trafficOverview?.adDensityRisk !== 'N/A'">
                <div class="d-inline-block risk-meter text-capitalize {{data?.trafficOverview?.adDensityRisk}}">
                  <img src="/assets/images/icon-meter-{{data?.trafficOverview?.adDensityRisk}}-white.svg"
                    alt="Risk Meter Icon">
                  {{data?.trafficOverview?.adDensityRisk}}
                </div>
              </ng-container>
              <ng-container *ngIf="data?.trafficOverview?.adDensityRisk === 'N/A'">
                N/A
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item label='Ad Frequency'>

            <span #value>
              <ng-container *ngIf="data?.trafficOverview?.adDensity !== 'N/A'">
                {{data?.trafficOverview?.adDensity | rounddecimal:2}} Per 10 Minute Period
              </ng-container>
              <ng-container *ngIf="data?.trafficOverview?.adDensity === 'N/A'">
                N/A
              </ng-container>
            </span>
          </info-list-item>
        </div>
      </div>
    </div>
  </div>
  <div class='col-lg-6 info-row'>
    <div class="info-column">
      <div class="info-section">
        <div class="info-list-2">
          <div class="divider d-lg-none"></div>
          <info-list-item label='IVT Free Users' [lock]='isFreemium'
            labelTooltip="The percentage of the app's individual user-base not responsible for presence of invalid traffic.">
            <span #value>
              {{data?.trafficOverview?.ivtFreeUsersRate | perc:'1.2-2'}}
            </span>
          </info-list-item>

          <info-list-item label='Est. Daily Reach' labelTooltip="Est. Daily Reach">
            <span #value>
              <ng-container *ngIf="data?.trafficOverview?.dailyActiveUsers !== 'N/A'">
                up to {{data?.trafficOverview?.dailyActiveUsers | roundsig: '0a'}}
              </ng-container>
              <ng-container *ngIf="data?.trafficOverview?.dailyActiveUsers === 'N/A'">
                N/A
              </ng-container>
            </span>
          </info-list-item>

          <info-list-item label='Est. Monthly Reach' labelTooltip="Est. Monthly Reach">
            <span #value>
              <ng-container *ngIf="data?.trafficOverview?.monthlyActiveUsers !== 'N/A'">
                up to {{data?.trafficOverview?.monthlyActiveUsers | roundsig:'0a'}}
              </ng-container>
              <ng-container *ngIf="data?.trafficOverview?.monthlyActiveUsers === 'N/A'">
                N/A
              </ng-container>
            </span>
          </info-list-item>

          <ng-container *ngIf="hasAdSpendPermission">
            <info-list-item label='Ad Spend' [lock]='isFreemium'>

              <span #value>
                <ng-container *ngIf="data?.trafficOverview?.adSpend && data?.trafficOverview?.adSpend != 'N/A'">
                  Est.
                </ng-container>
                {{data?.trafficOverview?.adSpend | roundsig:'0.0a'}}
              </span>
            </info-list-item>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<app-follow-unlock label="Additional IVT Risks" (followClick)="follow()" *ngIf="!isFollowing && isFreemium">
</app-follow-unlock>

<ng-container *ngIf="isFreemium || byOverallStats?.length > 0">
  <div class="row">
    <div class="col-lg-12">
      <div class="container-fluid pl-0 info-list has-info-icon height-unset mt-32px">
        <h3 class="sub-title">
          Overall Traffic Overlap Trends
        </h3>
      </div>
    </div>
  </div>
  <app-data-table-component [headers]="headers" minWidth="650px" [currentSort]="'impOverlapRate'"
    [data]="byOverallStats" [limit]="isFreemium ? 5 : 10" (itemClick)="goTo($event)"
    [maxValueMapping]="byOverallMaxValueMapping"></app-data-table-component>
</ng-container>

<ng-container *ngIf="isFreemium || byIvtStats?.length > 0">
  <div class="row">
    <div class="col-lg-12">
      <div class="container-fluid pl-0 info-list has-info-icon height-unset mt-32px">
        <h3 class="sub-title">
          Traffic Overlap Trends by IVT
        </h3>
      </div>
    </div>
  </div>
  <app-data-table-component [headers]="headers" minWidth="650px" [currentSort]="'impOverlapRate'" [data]="byIvtStats"
    [limit]="isFreemium ? 5 : 10" (itemClick)="goTo($event)" [maxValueMapping]="byIvtMaxValueMapping">
  </app-data-table-component>
</ng-container>

<ng-template #titleTemplate let-item='item' let-row='row'>
  <div class='d-flex align-items-center'>
    <ng-container *ngIf='row.icon !== "N/A"'>
      <div><img class="app-icon" src="{{row.icon}}" alt="CTV Icon" /></div>
    </ng-container>
    <ng-container *ngIf='row.icon === "N/A"'>
      <div><img class="app-icon" src="/assets/images/logo-grey-16x16.png" alt="Grey Logo" /></div>
    </ng-container>

    <div class="ml-2 overflow-hidden">
      <div class="app-title">{{item}}</div>
      <ng-container *ngIf='!isFreemium'>
        <risk-heat-meter [risk]='row.risk'></risk-heat-meter>
      </ng-container>
      <ng-container *ngIf='isFreemium'>
        <div class="freemium-lock"><i class="fa fa-lock"></i></div>
      </ng-container>
    </div>
  </div>
</ng-template>
